import { Article, Person } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { VoyageFormField } from "./VoyageFormField";

export const VoyageAccounts = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <Person style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Accounts")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <VoyageFormField label={t("VesselAgentAccount")} type={dataState.IsView ? "disabled" : "foreignKey"} entity="Account" filterField={'AccountCode'} labelFields={['AccountCode']} extraFields={[{key: 'Id', value: 'IdVesselAgentAccount'}, {key: 'AccountCode', value: 'VesselAgentAccountCode'}]} code="VesselAgentAccountCode"  data={dataState} setData={setDataState} />
            <VoyageFormField label={t("VesselLineAccount")} type={dataState.IsView ? "disabled" : "foreignKey"} entity="Account" filterField={'AccountCode'} labelFields={['AccountCode']} extraFields={[{key: 'Id', value: 'IdVesselLineAccount'}, {key: 'AccountCode', value: 'VesselLineAccountCode'}]} code="VesselLineAccountCode"  data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}